import { useEffect, useMemo, useState } from "react";

import { Box, Grid, Typography } from "@material-ui/core";
import TablePagination from "@material-ui/core/TablePagination";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import SimpleTable from "../../../../components/Table/Table";
import { CHAT_QUEUE_TABLE_HEADERS } from "../../../../constants/strings";
import { fetchChatQueueAccounts } from "../../../../features/customerSettings/customerSettings.action";
import { CHAT_QUEUE_ACCOUNTS_PAGE_SIZE } from "../../../../features/customerSettings/customerSettings.constants";
import { prepareChatQueueTableData } from "../../../../features/customerSettings/customerSettings.models";
import { ignoreCatch } from "../../../../utils/async";
import TablePaginationActions from "../../../main/components/tableComponents/TablePaginationActions";
import styles from "./ChatQueueAccountsTable.module.scss";

const ChatQueueAccountsTable = ({
  title,
  queueType,
  account,
  fetchAccounts,
}) => {
  const [page, setPage] = useState(0);
  const [items, setItems] = useState([]);
  const [total, setTotal] = useState(null);

  useEffect(() => {
    let cancelled = false;

    ignoreCatch(
      fetchAccounts({
        queueType,
        account,
        page,
        pageSize: CHAT_QUEUE_ACCOUNTS_PAGE_SIZE,
      }).then((result) => {
        if (!cancelled) {
          setItems(result?.items || []);
          setTotal(result?.total || 0);
        }
      })
    );

    return () => {
      cancelled = true;
    };
  }, [account, fetchAccounts, page, queueType]);

  const tableData = useMemo(() => prepareChatQueueTableData(items), [items]);

  if (account && total === 0) {
    return null;
  }

  return (
    <Box display="flex" flexDirection="column" width="100%" mt={4}>
      <Typography className={styles.titleText}>{`${title}:`}</Typography>
      <Box className={styles.table} mt={2}>
        <SimpleTable
          headerRows={CHAT_QUEUE_TABLE_HEADERS}
          cellStyles={styles["table-cell"]}
          input={{
            value: tableData,
          }}
        />
        <Grid container>
          <TablePagination
            rowsPerPageOptions={[]}
            count={total || 0}
            rowsPerPage={CHAT_QUEUE_ACCOUNTS_PAGE_SIZE}
            component="div"
            page={page}
            onChangePage={(_, nextPage) => setPage(nextPage)}
            className={styles.pagination}
            ActionsComponent={TablePaginationActions}
            labelDisplayedRows={({ from, to, count }) => (
              <span className={styles.counter}>
                {`RESULTS ${from} TO ${to} (OF ${count})`}
              </span>
            )}
          />
        </Grid>
      </Box>
    </Box>
  );
};

ChatQueueAccountsTable.propTypes = {
  title: PropTypes.string,
  queueType: PropTypes.string,
  account: PropTypes.string,
  fetchAccounts: PropTypes.func,
};

const mapDispatchToProps = (dispatch) => ({
  fetchAccounts: (query) => dispatch(fetchChatQueueAccounts(query)),
});

export default connect(null, mapDispatchToProps)(ChatQueueAccountsTable);
